import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrialLicenseWarningComponent } from '../trial-message/trial-license-warning.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    TrialLicenseWarningComponent
  ],
  imports: [CommonModule, TranslateModule],
  exports: [
    TrialLicenseWarningComponent
  ]
})
export class PhBhpFeatureComponentsModule {}
